module.exports = __webpack_public_path__ + "img/Logo PIFS.d4c6b755.svg";